import MenuWithSearch from '../MenuWithSearch'

const Content = ({ loading, isEmpty, children }) => {
  if (loading) return <MenuWithSearch.Loader />
  if (isEmpty) return <MenuWithSearch.Empty>No tags found</MenuWithSearch.Empty>
  return children
}

export default Content
